declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, SaveNewsRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
//import { DBOperation } from '../../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

@Component({
  selector: 'news',
  templateUrl: './news.modal.html',
  styleUrls: ['./news.modal.scss']
})

export class NgbNewsModal implements OnInit {


  @Input() ActorDocCode;
  @Input() DownloadActorImageFileExtension: string;
  @Input() DownloadActorImageFile: string;

  @Input() CanEdit: number;
  @Input() CanShow: number;

  DOB: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  CreatedAt: NgbDateStruct;
  RecommendedPackage: string;
  Doctor: string;
  PackageCost: number;
  SelectEmi: boolean;
  Concerns: string;
  AddRemarks: string;
  file: File;
  fileList: FileList;



  FileExtension: string = "";
  MaritalStatus: string;
  JobType: string;
  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  DocFriendlyName: string = "";
  

  CurrentSaveNewsRequest: SaveNewsRequest;
  CurrentDownloadFileRequestRequest: DownloadFileRequest;

  CurrentActorDocController: ActorDocController[];

  @ViewChild('f') IdentitiesDocForm: NgForm;
  public UploadActorDoc: any;

  public CanDownLoadActorDoc: number

  public CanNurseView: number =0 ;



  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {

    this.CurrentSaveNewsRequest = new SaveNewsRequest();

    //this.CurrentSaveNewsRequest.ActorCode = "43572";
    this.CurrentSaveNewsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    if (AppData.Instance().UserLoginDetails.ActorType === 3) {
      this.CanDownLoadActorDoc = 0;
      this.CanNurseView = 1;
    }
    else {
      this.CanDownLoadActorDoc = 1;
      this.CanNurseView = 0;
    }

    this.CurrentActorDocController = new Array<ActorDocController>();

    this.CurrentDownloadFileRequestRequest = new DownloadFileRequest();
    this.CurrentDownloadFileRequestRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    //this.GetActorDocController();

  }



 
  onSubmit() {
    //this.CurrentSaveCounsellingPlanRequest.CounsellingPlanCode = this.MaritalStatus;
    this.CurrentSaveNewsRequest.CreatedAt = new Date(this.parserFormatter.format(this.CreatedAt));
    this.CurrentSaveNewsRequest.ConditionalOperator = 10;
    //this.CurrentSaveCounsellingPlanRequest.RecommendedPackage = this.Recomm
    //this.CurrentSaveCounsellingPlanRequest.CounsellingDoctor = this.Doctor;
    //this.CurrentSaveCounsellingPlanRequest.SelectEmi = this.SelectEmi;
    //this.CurrentSaveCounsellingPlanRequest.FinancialStatus = this.FinancialStatus;
    //this.CurrentSaveCounsellingPlanRequest.Remarks = this.AddRemarks;
    //this.CurrentSaveCounsellingPlanRequest.Concerns = this.Concerns;
    //this.CurrentSaveCounsellingPlanRequest.TreatmentPlan;
    //this.CurrentSaveCounsellingPlanRequest.StartDate;
    //this.CurrentSaveCounsellingPlanRequest.RecommendedPackage;
    //this.CurrentSaveCounsellingPlanRequest.CounsellingDoctor;
    //this.CurrentSaveCounsellingPlanRequest.PackageCost;
    //this.CurrentSaveCounsellingPlanRequest.SelectEmi;
    //this.CurrentSaveCounsellingPlanRequest.FinancialStatus;
   
    //this.CurrentSaveCounsellingPlanRequest.Concerns;
    //this.CurrentSaveCounsellingPlanRequest.Remarks="";
    //this.CurrentSaveCounsellingPlanRequest.Potential;
    //this.CurrentSaveCounsellingPlanRequest.ConditionalOperator = 10;
    //this.CurrentSaveCounsellingPlanRequest.CounsellingDoctor = "";
    //this.CurrentSaveCounsellingPlanRequest.CounsellingPlanCode = "";
    //this.CurrentSaveCounsellingPlanRequest.PlanStatus = "Created";
    //this.CurrentSaveCounsellingPlanRequest.Potential = "";
    //this.CurrentSaveCounsellingPlanRequest.TreatmentPlan = "";
    this.CurrentSaveNewsRequest.NewsCode = 0;
    this.CurrentSaveNewsRequest.CreatedBy = "";
    this.CurrentSaveNewsRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;


    this.actorservice.SaveNewsList(this.CurrentSaveNewsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  
private stopRefreshing() {
  this.loaderService.displayLoader(false);
  this.isRequesting = false;
}
  private StartRefreshing() {
  this.loaderService.displayLoader(true);
  this.isRequesting = true;
  }
  editfollicular() {
    this.router.navigate(['nurse/editfollicular']);
    this.activeModal.close();
  }
}





  //GetActorDocController() {
  //  this.StartRefreshing();
  //  this.docservice.GetActorDocController(this.CurrentActorDocRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentActorDocController = this.ApiResData.Result;
  //        this.initGridButton();
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //    (error) => {

  //      if (error == "401 - Unauthorized") {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();



  //      }
  //      else {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();
  //      }
  //    }


  //    );

  //}

  

  /////////////////////////



  //

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start














  /////////////////////////

